import React from 'react';
import {
    Spinner
} from '@shopify/polaris';
import { apiFetch as fetch } from '../../common/Helpers';
import TagGroupFormComponent from './TagGroupFormComponent';
import { UIAttributeFilter, UICustomerAddressesFilter, ProductAttributePathSettings, AttributePathSettings } from '../../common/UICustomerFilter';

class TagGroupPage extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            loading: true,
            tagGroup: null,
            editId: null
        };

        const { params } = this.props.match;

        if (params.id) {
            this.state.editId = params.id
        }
    }

    render() {

        var title = "Create Tag Group";
        var actionTitle = "Create";

        if (this.state.editId != null) {
            title = "Update Tag Group";
            actionTitle = "Update";
        }

        return (
            <React.Fragment>
                {this.state.loading && <Spinner accessibilityLabel="Loading" size="large" color="teal" />}
                {!this.state.loading && <TagGroupFormComponent
                    title={title}
                    actionTitle={actionTitle}
                    tagGroup={this.state.tagGroup}
                    onAction={this.handleSaveOrCreate}
                />}
            </React.Fragment>
        );
    }

    handleSaveOrCreate = (tagGroup) => {

        let body = JSON.stringify({ ...tagGroup });
        let method = "POST";

        if (this.state.editId != null) {
            method = "PUT";
            body = JSON.stringify({
                ...tagGroup,
                id: this.state.editId
            });
        }

        fetch(`api/tagGroups`, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
            },
            body: body
        }).then(() => {
            this.props.history.push("/tag-groups");
        });
    }

    componentDidMount() {
        if (this.state.editId != null) {
            this.fetchTagGroup();
        }
        else {
            this.setState({ loading: false })
        }
    }

    fetchTagGroup = () => {
        fetch(`api/tagGroups/${this.state.editId}`, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => {

                var tagGroup = {
                    name: data.name,
                    color: data.color,
                    tags: data.tags,
                    resourceType: data.resourceType,
                    rule: null
                }

                var tagGroupRule = null;

                if (data.rule != null) {

                    tagGroupRule = {
                        ruleConstraint: data.rule.constraint,
                        ruleFilterLogicalOperator: "And",
                        ruleFilterChildren: []
                    };

                    if (data.rule.filter != null) {

                        let settings = AttributePathSettings;

                        if (tagGroup.resourceType === "Product") {
                            settings = ProductAttributePathSettings
                        }
                        // TODO: this is shared coded should be extracted
                        let filters = data.rule.filter.children.map((_, index) => {

                            if (_.filterType === "AttributeFilter") {
                                return UIAttributeFilter.fromBody(index + 1, _, settings);
                            }

                            if (_.filterType === "CustomerAddressesFilter") {
                                return UICustomerAddressesFilter.fromBody(index + 1, _);
                            }

                            throw new Error("Unknown filter type");
                        });

                        tagGroupRule.ruleFilterChildren = filters;
                        tagGroupRule.ruleFilterLogicalOperator = data.rule.filter.logicalOperator;
                    }

                    tagGroup.rule = tagGroupRule;
                }

                this.setState({
                    tagGroup: tagGroup,
                    loading: false
                });
            }
            );
    }
}

export default TagGroupPage;